import { Camera } from "lucide-react";

const ART = {
  lotus: (
    <g>
      <path d="M100 150c-18-22-18-52 0-80 18 28 18 58 0 80z" />
      <path d="M100 150c-30-8-48-34-46-66 26 10 42 36 46 66z" />
      <path d="M100 150c30-8 48-34 46-66-26 10-42 36-46 66z" />
      <path d="M100 152c-40 4-68-12-80-40 30-4 60 10 80 40z" />
      <path d="M100 152c40 4 68-12 80-40-30-4-60 10-80 40z" />
      <path d="M50 162h100" />
    </g>
  ),
  mandir: (
    <g>
      <path d="M100 28v14" /><path d="M78 72c0-18 10-30 22-30s22 12 22 30z" />
      <path d="M62 72h76v12H62z" /><path d="M68 84v80M132 84v80" />
      <path d="M84 164v-44c0-10 7-18 16-18s16 8 16 18v44" /><path d="M54 164h92v8H54z" />
    </g>
  ),
  panel: (
    <g>
      <rect x="44" y="30" width="112" height="140" />
      <rect x="58" y="44" width="84" height="112" />
      <circle cx="100" cy="100" r="26" /><circle cx="100" cy="100" r="12" />
      <path d="M100 44v30M100 126v30M58 100h16M126 100h16" />
    </g>
  ),
  furniture: (
    <g>
      <path d="M40 92h120v12H40z" /><path d="M50 104l-6 64M150 104l6 64M62 104l4 48M138 104l-4 48" />
      <path d="M66 140h68" /><path d="M64 92V60h72v32" />
    </g>
  ),
};

export const PhotoSlot = ({ art = "panel", label = "Genuine photo coming soon", className = "", testId }) => (
  <div data-testid={testId}
    className={`relative overflow-hidden bg-[linear-gradient(140deg,#f4ede0,#e6dccb)] grain ${className}`}>
    <svg viewBox="0 0 200 200" className="absolute inset-0 m-auto h-[62%] w-[62%] text-[#a87f2a] transition-transform duration-700 group-hover:scale-105"
      fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" aria-hidden="true">
      {ART[art] || ART.panel}
    </svg>
    <span className="absolute left-3 bottom-3 inline-flex items-center gap-1.5 rounded-full bg-white/85 backdrop-blur px-3 py-1 font-mono-tech text-[11px] uppercase tracking-[0.14em] text-slate-700">
      <Camera className="h-3.5 w-3.5" /> {label}
    </span>
  </div>
);
